import { CommonModule } from '@angular/common';
// Modules
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ColorPickerModule } from 'NewAngular/features/components/inputs/color-picker/color-picker.module';
import { DateRangeModule } from 'NewAngular/features/components/date-controls/date-range/date-range.module';
import { FullYearDateRangeModule } from 'NewAngular/features/components/date-controls/full-year-date-range/full-year-date-range.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { MultiItemAutocompleteModule } from 'SearchApp/ts/features/multi-item-autocomplete/multi-item-autocomplete.module';
import { RadioButtonGroupModule } from 'NewAngular/features/components/inputs/radio-button-group/radio-button-group.module';
import { ScatterPlotModule } from '../scatter-plot/scatter-plot.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { SkeletonLoadersListModule } from 'NewAngular/features/components/loaders/skeleton-loaders-list/skeleton-loaders.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
// This module exports the components that are used on both versions of the scatter plot page:
// - The main scatter plot page, which includes all features, the top nav bar, and side menu.
// - The scatter plot editor page, which is a simplified version used only for editing interactive scatter plots in the Chart Editor Modal.
export class ScatterPlotPageSharedModule {
}
ScatterPlotPageSharedModule.ɵfac = function ScatterPlotPageSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotPageSharedModule)(); };
ScatterPlotPageSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ScatterPlotPageSharedModule });
ScatterPlotPageSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        AutocompleteInPlaceModule,
        ColorPickerModule,
        CommonModule,
        DateRangeModule,
        FullYearDateRangeModule,
        HelpModalModule,
        IconModule,
        LegacyAssetConversionCheckerModule,
        ModalBaseModule,
        MultiItemAutocompleteModule,
        RadioButtonGroupModule,
        ScatterPlotModule,
        SecurityListSelectorModalModule,
        SimpleDropdownModule,
        SingleDatePickerModule,
        SingleSelectDropdownModule,
        SkeletonLoadersListModule,
        TooltipModule] });
